module.exports = __webpack_public_path__ + "static/media/home-button.fe1f2c40.png";